import { useState } from "react";

export interface DateRange {
    startDate: string;
    endDate: string;
}

export interface UseDateRangeFilterReturn {
    dateRange: DateRange;
    setDateRange: (range: DateRange) => void;
    dateRangeFilterProps: {
        dateRange: DateRange;
        onDateRangeChange: (range: DateRange) => void;
    };
    clearDateRange: () => void;
}

export function useDateRangeFilter(
    defaultStart?: string,
    defaultEnd?: string,
): UseDateRangeFilterReturn {
    const [dateRange, setDateRange] = useState<DateRange>({
        startDate: defaultStart || "",
        endDate: defaultEnd || "",
    });

    const clearDateRange = () => {
        setDateRange({ startDate: "", endDate: "" });
    };

    return {
        dateRange,
        setDateRange,
        dateRangeFilterProps: {
            dateRange,
            onDateRangeChange: setDateRange,
        },
        clearDateRange,
    };
}
